import { Link, useSearchParams } from "react-router-dom";
import Card from "../layouts/Card";
import white from "/cywe-assets/card/white.png";
import donateQR from "/donate-qr.svg";
import Button from "../layouts/Button";

const defaultRedirect = "https://unclewallysworld.com/";

export default function Donate() {
	const [searchParams, _setSearchParams] = useSearchParams();

	const redirect = searchParams.get("redirect") ?? defaultRedirect;
	const color = searchParams.get("color")!;

	// Parse the redirect url
	let url;

	try {
		url = new URL(redirect);
	} catch (err) {
		console.error("Failed to parse redirect url", err);

		url = new URL(defaultRedirect);
	}

	// Add additional params to the url
	url.searchParams.set("color", color);

	return (
		<Card bg={white}>
			<div className="min-h-screen flex flex-col items-center justify-center gap-4">
				<h1 className="text-4xl font-bold text-center">
					Would you like to donate to our Lets Color the World campaign?
				</h1>
				<img src={donateQR} className="size-96" />
			</div>
			<div className="absolute bottom-4 right-4">
				<Link to={url.href}>
					<Button>Next</Button>
				</Link>
			</div>
		</Card>
	);
}
